import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHistoryFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 2C12.8438 2 15.4688 3.53125 16.9062 6C18.3438 8.5 18.3438 11.5312 16.9062 14C15.4688 16.5 12.8438 18 10 18C7.125 18 4.5 16.5 3.0625 14C1.625 11.5312 1.625 8.5 3.0625 6C4.5 3.53125 7.125 2 10 2ZM9.25 5.75L9.25 10C9.25 10.25 9.375 10.5 9.5625 10.625L12.5625 12.625C12.9063 12.875 13.375 12.7812 13.625 12.4375C13.8438 12.0937 13.75 11.625 13.4063 11.375L10.75 9.625L10.75 5.75C10.75 5.34375 10.4062 5 10 5C9.5625 5 9.25 5.34375 9.25 5.75Z"
	})
});
const ForwardRef = forwardRef(SvgHistoryFilled);
export default ForwardRef;
